import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { dateTimeFormatter, readCookie } from '@/tools/tools';
import { getStatusCouponList as _getStatusCouponList, getInstruction as _getInstruction } from '@/services/http';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.isLoading = false; // 加载
    _this.showInstructions = false; // 显示使用说明
    _this.activeIndex = 0; // 0未使用，1已使用，2已过期
    _this.pageNo = 1; // 页数
    _this.pageSize = 8; // 条数
    _this.totalnumber = 0;
    _this.couponList = []; // 优惠券列表
    _this.instruction = ''; // 使用说明
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getStatusCouponList(0);
            case 2:
              _context.next = 4;
              return this.getInstruction();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "handleCouponTab",
    value: function handleCouponTab(index) {
      this.pageNo = 1;
      this.getStatusCouponList(index);
    }
  }, {
    key: "getStatusCouponList",
    value: function () {
      var _getStatusCouponList2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(num) {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              anchor = readCookie('anchor');
              this.couponList = [];
              this.activeIndex = num;
              this.totalnumber = 0;
              this.isLoading = true;
              _context2.next = 7;
              return _getStatusCouponList({
                useStatus: this.activeIndex,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                companyId: 1,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : ''
              });
            case 7:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.totalnumber = res.data.data.total;
                this.couponList = res.data.data.list.map(function (item) {
                  var data = item;
                  data.useStartDate = dateTimeFormatter(item.useStartDate);
                  data.useEndDate = dateTimeFormatter(item.useEndDate);
                  return data;
                });
                this.isLoading = false;
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getStatusCouponList(_x) {
        return _getStatusCouponList2.apply(this, arguments);
      }
      return getStatusCouponList;
    }()
  }, {
    key: "showDesc",
    value: function showDesc() {
      this.showInstructions = true;
    }
  }, {
    key: "getInstruction",
    value: function () {
      var _getInstruction2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _getInstruction();
            case 2:
              res = _context3.sent;
              if (res.data.code === 100) {
                this.instruction = res.data.data;
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getInstruction() {
        return _getInstruction2.apply(this, arguments);
      }
      return getInstruction;
    }()
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(val) {
      this.pageNo = val;
      this.getStatusCouponList(this.activeIndex);
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(val) {
      this.pageSize = val;
      this.getStatusCouponList(this.activeIndex);
    }
  }]);
}(Vue);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
__decorate([State('user')], default_1.prototype, "userInfo", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;